import { Chip, Link, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { EmailMessageListItemDto, IPagingData } from '@sr/dto';
import { useState } from 'react';
import { ViewEmailModal } from 'components/Companies/Feed/view-email-modal';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { DEFAULT_PAGINATION, GridLayout } from 'shared/ui/grid-layout';
import { LinkToCompany } from 'shared/ui/links/link-to-company';
import { LinkToLead } from 'shared/ui/links/link-to-lead';
import { formatDateTime } from 'utils/date-format-helpers';
import { emailParserApi } from './email-parser.api';

const columns = ['ID', 'messageIdCRC32', 'IN/OUT', 'От кого', 'Тема', 'Дата получения', 'Лид', 'Клиент'];

const EmailMessageRow = ({ message, onOpen }: { message: EmailMessageListItemDto; onOpen: (id: number) => void }) => (
  <TableRow hover>
    <TableCell>{message.id}</TableCell>
    <TableCell sx={{ fontFamily: 'monospace' }}>{message.messageIdCRC32}</TableCell>
    <TableCell>
      <Chip
        size="small"
        label={message.type}
        color={message.type === 'IN' ? 'primary' : 'success'}
        title={message.type === 'IN' ? 'Входящее письмо' : 'Исходящее письмо'}
      />
    </TableCell>
    <TableCell><Typography variant="body2">{message.from}</Typography></TableCell>
    <TableCell>
      <Link
        component="button"
        type="button"
        onClick={() => onOpen(message.id)}
        sx={{ textAlign: 'left' }}
      >
        {message.subject || '(Без темы)'}
      </Link>
    </TableCell>
    <TableCell>{formatDateTime(message.date)}</TableCell>
    <TableCell>{message.lead ? <LinkToLead lead={message.lead}>{message.lead.id}</LinkToLead> : '—'}</TableCell>
    <TableCell>
      {message.clients.length ? (
        <Stack spacing={0.5} alignItems="flex-start">
          {message.clients.map((client) => <LinkToCompany key={client.id} company={client} />)}
        </Stack>
      ) : '—'}
    </TableCell>
  </TableRow>
);

export const EmailMessages = ({ accountId }: { accountId: number }) => {
  const [paging, setPaging] = useState<IPagingData>(DEFAULT_PAGINATION);
  const [selectedMessageId, setSelectedMessageId] = useState<number | null>(null);
  const { data, isLoading, isFetching, error } = emailParserApi.useGetEmailMessagesQuery({ accountId, paging });

  return (
    <>
      <GridLayout<EmailMessageListItemDto>
        columns={columns}
        items={data?.items ?? []}
        isLoading={isLoading || isFetching}
        error={extractNestJsErrorMessage(error)}
        pagingData={paging}
        onChangePaging={setPaging}
        totalItemsCount={data?.totalItemsCount ?? 0}
        noItemsText="Загруженных сообщений нет"
        itemRender={(message) => <EmailMessageRow key={message.id} message={message} onOpen={setSelectedMessageId} />}
      />
      {selectedMessageId !== null && (
        <ViewEmailModal open id={selectedMessageId} onClose={() => setSelectedMessageId(null)} />
      )}
    </>
  );
};
